<template>
  <div class="pb-2">
    <!-- loading -->
    <div v-if="loadpage" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>

    <div v-if="!loadpage">
      <b-card no-body>
        <b-card-header class="d-flex justify-content-between align-items-center flex-wrap">
          <h4 class="mb-0">สถานะใบสั่งซื้อ</h4>
          <div class="text-right">จำนวน : {{ totalRows }}</div>
        </b-card-header>
        <hr class="my-0 mx-2">

        <!-- filters -->
        <b-card-body>
          <b-row>
            <b-col cols="12" md="4" class="mb-1">
              <label>เลขออเดอร์</label>
              <b-form-input v-model="srchOrderID" placeholder="ค้นหาเลขออเดอร์" />
            </b-col>
            <b-col cols="12" md="4" class="mb-1">
              <label>ลูกค้า</label>
              <b-form-input v-model="srchCustomer" placeholder="ชื่อ / รหัสลูกค้า" />
            </b-col>
            <b-col cols="12" md="4" class="mb-1">
              <label>ช่วงวันที่สั่ง</label>
              <div class="d-flex align-items-center">
                <flat-pickr v-model="dateFrom" class="form-control" :config="datePickerConfig" placeholder="จาก" />
                <span class="px-1">-</span>
                <flat-pickr v-model="dateTo" class="form-control" :config="datePickerConfig" placeholder="ถึง" />
              </div>
            </b-col>
          </b-row>
          <div class="text-right">
            <b-button variant="primary" @click="search()">ค้นหา</b-button>
          </div>
        </b-card-body>

        <!-- status tabs -->
        <b-tabs fill class="px-1" v-model="tabIndex" @input="onTabChange">
          <b-tab
            v-for="(s, i) in statusOptions"
            :key="i"
            :title="s.text"
            :title-link-class="s.color"
          />
        </b-tabs>

        <b-card-body class="pt-0">
          <b-table
            responsive
            :items="items"
            :fields="fields"
            bordered
            show-empty
            empty-text="ไม่มีรายการ"
            table-class="table-md-responsive text-nowrap"
          >
            <template #cell(no)="data">
              {{ data.index + 1 + (currentPage - 1) * perPage }}
            </template>

            <template #cell(orderID)="data">
              <b-link @click="orderDetail(data.item)"><u>{{ data.value }}</u></b-link>
            </template>

            <template #cell(customerName)="data">
              <div>{{ data.value }}</div>
              <small class="text-muted" v-if="data.item.customerCode">{{ data.item.customerCode }}</small>
            </template>

            <template #cell(photo)="data">
              <b-link
                v-if="data.item.orderItemPhotoLink"
                @click="showImg(data.item.orderItemPhotoLink)"
              >
                <b-img :src="data.item.orderItemPhotoLink" width="50px" height="50px" />
              </b-link>
            </template>

            <template #cell(productName)="data">
              <div class="text-truncate" style="max-width: 220px;" :title="data.item.orderItemTitle">
                {{ data.item.orderItemTitle }}
              </div>
            </template>

            <template #cell(productDetail)="data">
              <div>x {{ data.item.orderItemQuantity }}</div>
              <small class="text-muted d-block" v-if="data.item.orderItemProp1Text">
                {{ data.item.orderItemProp1Text }} : {{ data.item.orderItemProp1Value }}
              </small>
              <small class="text-muted d-block" v-if="data.item.orderItemProp2Text">
                {{ data.item.orderItemProp2Text }} : {{ data.item.orderItemProp2Value }}
              </small>
            </template>

            <template #cell(statusText)="data">
              <span :class="statusColor(data.item.statusID)">{{ data.value }}</span>
            </template>

            <template #cell(orderTotalBahtAmount)="data">
              <div class="text-right">฿ {{ format_price(data.value) }}</div>
            </template>

            <template #cell(created)="data">
              {{ formatDatetime(data.value) }}
            </template>

            <template #cell(actions)="data">
              <b-button
                size="sm"
                variant="outline-primary"
                @click="orderDetail(data.item)"
              >
                <feather-icon icon="ListIcon" class="mr-25" />
                รายละเอียด
              </b-button>
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="mt-1 mb-0"
          />
        </b-card-body>
      </b-card>
    </div>

    <!-- product image modal -->
    <b-modal ref="show-img" size="lg" hide-footer centered>
      <b-img class="px-0" :src="imgLink" fluid />
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BTable, BPagination, BButton, BSpinner,
  BFormInput, BRow, BCol, BLink, BImg, BModal, BTabs, BTab,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { format_price, formatDatetime } from '@/views/global_function.js'
import { header_token } from '@/views/token.js'
import { taobaoService_dotnet } from '@/views/global.js'
import axios from 'axios'

export default {
  name: 'AdminBranchOrderStatus',

  components: {
    BCard, BCardHeader, BCardBody, BTable, BPagination, BButton, BSpinner,
    BFormInput, BRow, BCol, BLink, BImg, BModal, BTabs, BTab,
    flatPickr,
  },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),

      loadpage: true,

      // status tabs
      statusOptions: [
        { text: 'ทั้งหมด', value: [0], color: '' },
        { text: 'รอตรวจสอบ', value: [0, 1, 2], color: 'text-dark' },
        { text: 'รอชำระเงิน', value: [3], color: 'text-warning' },
        { text: 'สั่งสินค้า', value: [6, 7], color: 'text-primary' },
        { text: 'ระหว่างขนส่ง', value: [8, 9], color: 'text-info' },
        { text: 'ได้รับสินค้า', value: [10], color: 'text-success' },
        { text: 'ยกเลิก', value: [11], color: 'text-danger' },
      ],
      tabIndex: 0,
      lastTab: 0,

      // filters
      srchOrderID: '',
      srchCustomer: '',
      dateFrom: null,
      dateTo: null,
      datePickerConfig: {
        altInput: true,
        altFormat: 'd-m-Y',
      },

      // table
      items: [],
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      fields: [
        { key: 'no', label: 'ลำดับ', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'orderID', label: 'เลขออเดอร์', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'customerName', label: 'ลูกค้า' },
        { key: 'photo', label: 'รูป', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'productName', label: 'ชื่อสินค้า' },
        { key: 'productDetail', label: 'รายละเอียด' },
        { key: 'statusText', label: 'สถานะ', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'orderTotalBahtAmount', label: 'ยอด (บาท)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'transportType', label: 'ขนส่ง', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'created', label: 'วันที่สั่ง', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'actions', label: 'จัดการ', thClass: 'text-center', tdClass: 'text-center' },
      ],

      // status colors (จาก all-order.vue)
      colorStatus: [
        { id: 1, color: 'text-dark' },
        { id: 2, color: 'text-dark' },
        { id: 3, color: 'text-warning' },
        { id: 6, color: 'text-primary' },
        { id: 7, color: 'text-primary' },
        { id: 8, color: 'text-info' },
        { id: 9, color: 'text-info' },
        { id: 10, color: 'text-success' },
        { id: 11, color: 'text-danger' },
      ],

      imgLink: '',
    }
  },

  computed: {
    branchID() {
      return this.userData && this.userData.data ? this.userData.data.branchID : null
    },
  },

  watch: {
    async currentPage() {
      await this.getList()
    },
  },

  async created() {
    await this.getList()
    this.loadpage = false
  },

  methods: {
    format_price, formatDatetime,

    statusColor(statusID) {
      const found = this.colorStatus.find(x => x.id === statusID)
      return found ? found.color : null
    },

    async getList() {
      const skip = (this.currentPage - 1) * this.perPage
      const response = await axios.post(
        taobaoService_dotnet + 'app/Branch/get-order-list',
        {
          branchID: this.branchID,
          statusIDList: this.statusOptions[this.tabIndex].value,
          orderID: this.srchOrderID.trim(),
          customerKeyword: this.srchCustomer.trim(),
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          skip,
          take: this.perPage,
        },
        { headers: header_token }
      )
      this.items = response.data.items || []
      this.totalRows = response.data.totalRows || 0
    },

    async search() {
      // ถ้าเปลี่ยนหน้า watch จะเรียก getList ให้เอง กันเรียกซ้ำ
      if (this.currentPage !== 1) {
        this.currentPage = 1
      } else {
        await this.getList()
      }
    },

    async onTabChange(index) {
      // b-tabs อาจ emit input ตอน mount ด้วยค่าเดิม -> กันโหลดซ้ำกับ created()
      if (index === this.lastTab) return
      this.lastTab = index
      await this.search()
    },

    orderDetail(item) {
      // เข้ารหัส base64 ทั้ง orderid / token / cusId (token/cusId เป็น identity ของลูกค้าเจ้าของ order)
      const enc = v => (v === null || v === undefined || v === '') ? '' : btoa(String(v))
      const url = '/admin-branch/order-detail'
        + '?orderid=' + encodeURIComponent(enc(item.orderID))
        + '&token=' + encodeURIComponent(enc(item.customerLoginToken))
        + '&cusId=' + encodeURIComponent(enc(item.customerID))
      window.open(url)
    },

    showImg(img) {
      this.imgLink = img
      this.$refs['show-img'].show()
    },
  },
}
</script>

<style scoped>
</style>
